// import { orderBy } from 'lodash';
// const orderedUser = orderBy(userQuery.data, ['date_created'], ['desc']);

import Table from 'react-bootstrap/Table';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faBan } from '@fortawesome/free-solid-svg-icons';

import { GO } from '@/types';
import { MODAL_TYPES as MDT } from '@/types/options';

import { formatDateByMDY } from '@/utils/format';

import { useAIModules } from '../api';

const iconByStatus = (status: string) => {
  if (status == 'ACTIVE') {
    return <FontAwesomeIcon size="lg" icon={faCheckCircle} color="green" />;
  }
  return <FontAwesomeIcon size="lg" icon={faBan} color="gray" />;
};

/**
 * AI modules Table
 * Created at 2025/04/23
 */
export const AIModuleTable = ({
  openBy,
}: {
  openBy: (type: string, context?: GO) => void;
}) => {
  const aiQuery = useAIModules();
  const aiModuleResponse = aiQuery.data;
  const aiModules = aiModuleResponse ? aiModuleResponse.data : [];
  // console.log(aiModules);
  if (!aiModules || aiModules.length == 0) {
    return <div>Loading AI module configs ...</div>;
  }
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>ID</th>
          <th>Label</th>
          <th>Back Module Key</th>
          <th>Description</th>
          <th>Is Default</th>
          <th>Status</th>
          <th>Companies</th>
          <th>Created At</th>
          <th>Operation</th>
        </tr>
      </thead>
      <tbody>
        {aiModules?.map((ai) => (
          <tr key={ai.ai_module_key}>
            <td>{ai.id}</td>
            <td>{ai.ai_module_key}</td>
            <td>{ai.back_module_key}</td>
            <td>{ai.description}</td>
            <td className="text-center">{ai.is_default ? 'Yes' : 'No'}</td>
            <td className="text-center">{iconByStatus(ai.status)}</td>
            <td>
              <ul>
                {ai.companies?.map((c) => (
                  <li key={c.company_id}>{`${c.label}[${c.company_id}]`}</li>
                ))}
              </ul>
            </td>
            <td>{formatDateByMDY(ai.date_created)}</td>
            <td>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm me-2"
                onClick={() => openBy(MDT.EDIT_AI_MODULE, ai)}
              >
                Edit
              </button>
              <button
                type="button"
                className="btn btn-outline-dark btn-sm me-2"
                onClick={() => openBy(MDT.EDIT_ITEM_AI_MODULE, ai)}
              >
                Items
              </button>
              {ai.status == 'ACTIVE' && (
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => openBy(MDT.DELETE_AI_MODULE, ai)}
                >
                  Disable
                </button>
              )}
              {ai.status == 'INACTIVE' && (
                <button
                  type="button"
                  className="btn btn-outline-success btn-sm"
                  onClick={() => openBy(MDT.ENABLE_AI_MODULE, ai)}
                >
                  Enable
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
